import { useState } from "react";

const games = [
  {
    name: "Call of Duty: Warzone",
    tag: "Battle Royale",
    img: "https://public.readdy.ai/ai/img_res/b048030355502233b8ebecdf8aab1eb4.jpg",
    rank: "Top 250 Global",
    kd: "4.2",
    wins: "580+",
    hours: "4,200",
    color: "from-green-900/40",
  },
  {
    name: "Escape From Tarkov",
    tag: "Tactical FPS",
    img: "https://readdy.ai/api/search-image?query=escape%20from%20tarkov%20style%20game%20cover%20dark%20industrial%20military%20gear%20soldier%20tactical%20shooter%20gritty%20atmosphere%20dramatic%20dark%20moody%20cinematic%20urban%20warfare%20ruins&width=400&height=520&seq=game-tarkov-2&orientation=portrait",
    rank: "Kappa Container",
    kd: "5.1",
    wins: "N/A",
    hours: "3,800",
    color: "from-amber-900/40",
  },
  {
    name: "Rainbow Six Siege",
    tag: "Tactical Shooter",
    img: "https://readdy.ai/api/search-image?query=rainbow%20six%20siege%20game%20cover%20art%20tactical%20special%20forces%20operator%20breach%20door%20urban%20combat%20dark%20cinematic%20poster%20dramatic%20military%20swat%20team&width=400&height=520&seq=game-r6-3&orientation=portrait",
    rank: "Diamond",
    kd: "3.6",
    wins: "220+",
    hours: "2,100",
    color: "from-blue-900/40",
  },
  {
    name: "PUBG",
    tag: "Battle Royale",
    img: "https://readdy.ai/api/search-image?query=pubg%20battlegrounds%20game%20cover%20art%20military%20soldier%20desert%20dramatic%20cinematic%20poster%20tactical%20shooting%20intense%20dark%20moody&width=400&height=520&seq=game-pubg-4&orientation=portrait",
    rank: "Conqueror",
    kd: "3.2",
    wins: "440+",
    hours: "2,600",
    color: "from-orange-900/40",
  },
];

const achievements = [
  { icon: "ri-trophy-fill", label: "Regional Champion", year: "2023", desc: "1st Place - Texas FPS Open" },
  { icon: "ri-medal-2-fill", label: "Top Sniper Award", year: "2022", desc: "50K+ sniper eliminations" },
  { icon: "ri-group-fill", label: "Clan Founder", year: "2019", desc: "Murks Battalion - 200+ members" },
  { icon: "ri-live-fill", label: "Featured Streamer", year: "2023", desc: "Twitch Partner Program" },
  { icon: "ri-fire-fill", label: "Longest Win Streak", year: "2022", desc: "32 consecutive BR wins" },
  { icon: "ri-star-fill", label: "Content Creator", year: "2024", desc: "1M+ total video views" },
];

export default function GameHighlights() {
  const [activeGame, setActiveGame] = useState(0);
  const game = games[activeGame];

  return (
    <section id="highlights" className="relative py-28 bg-urban-dark">
      <div className="absolute inset-0 opacity-5"
        style={{ backgroundImage: "repeating-linear-gradient(0deg, transparent, transparent 40px, #dc2626 40px, #dc2626 41px), repeating-linear-gradient(90deg, transparent, transparent 40px, #dc2626 40px, #dc2626 41px)" }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-8 md:px-16">
        <div className="flex items-center gap-4 mb-16">
          <div className="w-1 h-12 bg-red-600" />
          <div>
            <p className="font-rajdhani text-red-500 uppercase tracking-widest text-sm font-semibold">What I Play</p>
            <h2 className="font-bebas text-5xl md:text-6xl text-white tracking-wider">Game Highlights</h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {games.map((g, i) => (
            <button
              key={g.name}
              onClick={() => setActiveGame(i)}
              className={`relative overflow-hidden rounded-sm cursor-pointer transition-all duration-300 group ${
                activeGame === i ? "ring-2 ring-red-600 scale-105" : "opacity-70 hover:opacity-100"
              }`}
            >
              <div className="w-full h-56 md:h-72 overflow-hidden">
                <img
                  src={g.img}
                  alt={g.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className={`absolute inset-0 bg-gradient-to-t ${g.color} to-black/60`} />
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <span className="font-rajdhani text-xs text-red-400 uppercase tracking-widest font-semibold">{g.tag}</span>
                <span className="font-bebas text-white text-lg leading-tight tracking-wide">{g.name}</span>
              </div>
              {activeGame === i && (
                <div className="absolute top-3 right-3 w-6 h-6 bg-red-600 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-xs" />
                </div>
              )}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <span className="font-rajdhani text-xs text-red-500 uppercase tracking-widest font-semibold border border-red-900/50 px-3 py-1 rounded-sm">{game.tag}</span>
              <span className="font-rajdhani text-xs text-gray-500 uppercase tracking-widest">{game.rank}</span>
            </div>
            <h3 className="font-bebas text-4xl md:text-5xl text-white tracking-wider mb-6">{game.name}</h3>
            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="bg-urban-surface border border-urban-border rounded-sm p-5">
                <span className="font-bebas text-3xl text-red-500">{game.kd}</span>
                <p className="font-rajdhani text-gray-500 text-xs uppercase tracking-wider mt-1">K/D Ratio</p>
              </div>
              <div className="bg-urban-surface border border-urban-border rounded-sm p-5">
                <span className="font-bebas text-3xl text-red-500">{game.wins}</span>
                <p className="font-rajdhani text-gray-500 text-xs uppercase tracking-wider mt-1">Total Wins</p>
              </div>
              <div className="bg-urban-surface border border-urban-border rounded-sm p-5">
                <span className="font-bebas text-3xl text-red-500">{game.hours}</span>
                <p className="font-rajdhani text-gray-500 text-xs uppercase tracking-wider mt-1">Hours Played</p>
              </div>
            </div>
            <div className="bg-urban-surface border border-urban-border rounded-sm p-6">
              <p className="font-rajdhani text-gray-400 text-sm leading-relaxed">
                Old Man Murks brings <strong className="text-white">veteran-level game sense</strong> to every match. Ranked in the top percentile globally, with a play style built on patience, positioning, and precision. Every engagement is calculated &mdash; no panic, no spray and pray. Just methodical, tactical elimination.
              </p>
            </div>
          </div>

          <div
            className="relative h-80 md:h-96 overflow-hidden rounded-sm"
            style={{
              backgroundImage: `url("https://readdy.ai/api/search-image?query=fps%20game%20screenshot%20urban%20tactical%20military%20gameplay%20destroyed%20city%20night%20cinematic%20graphics%20dark%20atmosphere%20dramatic%20action%20war%20smoke%20military%20operator&width=700&height=500&seq=game-action-${activeGame}&orientation=landscape")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
                <span className="font-rajdhani text-xs text-red-400 uppercase tracking-widest font-semibold">Live Gameplay Footage</span>
              </div>
              <p className="font-bebas text-white text-2xl tracking-wider">{game.name} — Ranked Match</p>
            </div>
          </div>
        </div>

        <div className="border-t border-urban-border pt-16">
          <h3 className="font-bebas text-3xl text-white tracking-wider mb-8 text-center">
            Career <span className="text-red-500">Achievements</span>
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {achievements.map((a) => (
              <div
                key={a.label}
                className="bg-urban-card border border-urban-border rounded-sm p-5 hover:border-red-800/50 hover:-translate-y-1 transition-all duration-300 group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-red-900/30 border border-red-900/40 rounded-sm text-red-500 text-lg flex-shrink-0 group-hover:bg-red-800/40 transition-colors">
                    <i className={a.icon} />
                  </div>
                  <div>
                    <p className="font-rajdhani font-bold text-white text-sm">{a.label}</p>
                    <p className="font-rajdhani text-gray-500 text-xs mb-1">{a.desc}</p>
                    <span className="font-bebas text-red-600 text-sm">{a.year}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
